<template>
	<div class="personal-attention">
		<template v-for="(item,index) in attentionList">
			<div class="item"   @click="skipDetails(item)">
				<img :src="item.banner" alt="">
				<h3>{{item.name}}</h3>
			</div>
		</template>
	</div>
</template>
<script>
	import {PersoanalAttention} from '../../config/interface.js'
	export default{
		data(){
			return{
				attentionList:[],    //关注列表
			}
		},
		mounted(){
			this.init();
		},
		methods:{
			//初始化
			init(){
				const url=PersoanalAttention;
				let params={};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						data.columns.forEach((item,index)=>{
							item.type=0;   //0代表专栏 1代表会议
							this.attentionList.push(item);
						})
						data.meetings.forEach((item,index)=>{
							item.type=1;   //0代表专栏 1代表会议
							this.attentionList.push(item);
						})
					}
				})
			},
			//跳转详情
			skipDetails(item){
				switch(item.type){
					case 0:
					this.$router.push({
						path:'/column/details',
						query:{
							id:item.id
						}						
					});
					break;
					case 1:
					this.$router.push({
						path:'/meeting/details',
						query:{
							meeting_id:item.id
						}						
					});
					break;
				}
			}
		}
	}
</script>
<style lang="scss">
	.personal-attention{
		padding:0 12px;
		.item{
			padding:14px 0px;
			border-bottom: 1px solid #BFBFBF;
			img{
				width:100%;
				border-radius:5px;
			}
			h3{
				font-size: 17px;
				color: #090909;
				letter-spacing: 0.6px;
				padding-top:10px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/personal/MyAttention.vue